import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { useNavigate } from 'react-router';
import * as Common from '_common';
import * as Utils from '_utils';
import { debugComponentRegister } from '_componentRegister';
import * as Components from '_components';
import * as Styles from './DebugPage.module.scss';
export function DebugScreen(props) {
    const debugRegister = debugComponentRegister();
    const navigate = useNavigate();
    let selectedId = 'Index';
    const tabs = [];
    tabs.push({
        type: 'tab',
        properties: { id: 'Index', title: 'Index' },
        children: [{ type: 'Debug_Index' }],
    });
    function getGroup(value) {
        if (value.indexOf('#') > 0) {
            return value.split('#')[1];
        }
        return undefined;
    }
    function getValue(value) {
        if (value.indexOf('#') > 0) {
            return value.split('#')[0];
        }
        return value;
    }
    for (const key in debugRegister) {
        const value = debugRegister[key];
        tabs.push({
            type: 'tab',
            properties: { id: key, title: key, group: getGroup(value) },
            children: [
                {
                    type: 'Debug_controls',
                    children: [{ type: 'debug_' + getValue(value) }],
                },
            ],
        });
    }
    if (props.cmp && debugRegister[props.cmp]) {
        // TODO specific debug page
        selectedId = props.cmp;
    }
    const extraButtons = (_jsx(Components.BtnGroup, { children: _jsx(Components.Button, { onClick: () => navigate('/'), children: _jsx(Common.MLT, { cs: "Zav\u0159\u00EDt", en: "Close" }) }) }));
    return (_jsx(Components.TabsWidget, { tabs: tabs, selectedId: selectedId, setSelected: id => navigate('/Debug/' + id), title: "Debug page", extraBtns: extraButtons }));
}
export function Index(component, index) {
    const navigate = useNavigate();
    return (_jsxs(_Fragment, { children: [_jsx("h1", { children: "Html elements" }), _jsxs(Components.BtnGroup, { type: Components.BtnGroupType.Grid, children: [_jsx(Components.Button, { onClick: () => navigate('/Debug/Index'), children: "Fonts" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/Index'), children: "Colors" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/title'), children: "Title" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/Link'), children: "Links" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/List'), children: "Lists" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/Layout'), children: "Layout" })] }), _jsx("h1", { children: "Simple components" }), _jsxs(Components.BtnGroup, { type: Components.BtnGroupType.Grid, children: [_jsx(Components.Button, { onClick: () => navigate('/Debug/Button'), children: "Buttons" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/Index'), children: "Dropdown" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/Editor'), children: "Editor" })] }), _jsx("h1", { children: "Complex components" }), _jsxs(Components.BtnGroup, { type: Components.BtnGroupType.Grid, children: [_jsx(Components.Button, { onClick: () => navigate('/Debug/Widget'), children: "Widgets" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/Tabs'), children: "Tabs" }), _jsx(Components.Button, { onClick: () => navigate('/Debug/Presentation'), children: "Presentation" })] })] }));
}
export function DebugControls(component, index) {
    const [state, toggleButtons] = useToggles({
        errorOverlay: false,
    });
    return (_jsxs("div", { className: Styles.screen_root, children: [_jsxs("div", { className: Styles.context_toggles, children: ["Context:", toggleButtons] }), _jsx("div", { className: Styles.content + ' ' + Utils.classNames(state), children: Components.RenderChildren(component.children) })] }));
}
export function DebugPage(props) {
    return (_jsxs("div", { className: Styles.debug_page, children: [_jsx("div", { className: Styles.controls, children: props.controls }), _jsx("div", { className: Styles.inner_content, children: props.children })] }));
}
export function useToggles(value) {
    const [state, setState] = React.useState(value);
    function toggle(name) {
        const newState = { ...state };
        newState[name] = !newState[name];
        setState(newState);
    }
    function toggleButtons() {
        const result = [];
        for (const key in state) {
            result.push(_jsx(Components.Button, { isActive: state[key], onClick: () => toggle(key), children: key }, key));
        }
        return result;
    }
    return [state, toggleButtons()];
}
export function useOneOf(values) {
    const [state, setState] = React.useState(values[0]);
    function toggle(name) {
        setState(name);
    }
    function toggleButtons() {
        const result = [];
        for (const key of values) {
            result.push(_jsx(Components.Button, { isActive: state === key, onClick: () => toggle(key), children: key }, key));
        }
        return result;
    }
    return [state, toggleButtons()];
}
